/* @flow */
import * as React from 'react';

const ArrowYellowDown = props => (
  <svg width={12} height={16} viewBox="0 0 12 16" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFEF55"
      fillRule="evenodd"
      d="M5,1 L5,14 L1,10 C0.675,9.633 0.359,9.624 0,10 C0,10.3 0.045,10.424 0,11 L5,16 C5.537,15.998 5.564,15.987 6,16 C5.86,15.846 11,11 11,11 C11.053,10.32 11.043,10.004 11,10 C10.641,9.624 10.325,9.635 10,10 L6,14 L6,1 C6,0.224 5.776,0 6,0 C5.224,0 5,0.224 5,1 Z"
    />
  </svg>
);

export default ArrowYellowDown;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-yellow-down.js